var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrokenClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9478 21.9425C21.7993 21.9425 23.2982 20.4437 23.2982 18.5922C23.2982 16.7407 21.7993 15.2418 19.9478 15.2418C19.9363 15.2418 19.9248 15.2418 19.9133 15.2418C19.6182 12.5777 17.3527 10.5 14.6003 10.5C12.4268 10.5 10.56 11.7957 9.72433 13.6548C9.6975 13.6548 9.67067 13.651 9.64383 13.651C7.35533 13.651 5.5 15.5063 5.5 17.7948C5.5 20.0833 7.35533 21.9387 9.64383 21.9387",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0803 21.9397C21.8702 21.8702 23.298 20.3991 23.298 18.592C23.298 16.7405 21.7992 15.2416 19.9477 15.2416H19.9132C19.9028 15.1484 19.8901 15.0559 19.875 14.9641C20.2421 14.8263 20.6399 14.751 21.0554 14.751C22.7804 14.751 24.2026 16.0543 24.3904 17.7333H24.4134C25.5749 17.7333 26.5179 18.6763 26.5179 19.8378C26.5179 20.9993 25.5749 21.9423 24.4134 21.9423L20.0803 21.9397Z",
    fill: "#CAD1E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenClouds);
export default __webpack_public_path__ + "static/media/broken_clouds.b07c74d4d678b26658fc370b77c4e2e1.svg";
export { ForwardRef as ReactComponent };